import React from 'react';
import Grid from '@material-ui/core/Grid';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import * as utils from '../../../../helpers/utils';
import styles from './RightSideBar.module.css';
import { useRootStore } from '../../../../mobx/bridge';
import SMSChannelInfo from '../SMSChannelInfo/SMSChannelInfo';
import WebChatChannelInfo from '../WebChatChannelInfo/WebChatChannelInfo';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const RightSideBar = observer(function RightSideBar() {
  const { commonStore, settingsStore } = useRootStore();
  const { t } = useTranslation();

  const settings = settingsStore.getLoggedUserSettings;

  if (!settings.SelectedChannel) {
    return <span className={styles.channelName}>{t('Common.NoContactSelected')}</span>;
  }

  function closeCurrentComponent() {
    commonStore.setToggleRightSideComponent();
  }

  let mainComponent;

  if (settings.SelectedChannel.ChannelType.TypeId === utils.ChannelTypeEnum.SMS.TypeId) {
    mainComponent = <SMSChannelInfo />;
  } else if (settings.SelectedChannel.ChannelType.TypeId === utils.ChannelTypeEnum.WebChat.TypeId) {
    mainComponent = <WebChatChannelInfo />;
  }

  return (
    <Grid component="div" container data-testid="channelInfoContainer">
      <Grid component="div" container item xs={12}>
        {!commonStore.channelInfoInnerComponent ? (
          <React.Fragment>
            <Grid
              component="div"
              container
              item
              xs={12}
              justify="center"
              alignItems="center"
              className={styles.topBar}
            >
              <button
                type="button"
                className={styles.closeBtn}
                onClick={closeCurrentComponent}
                data-testid="channelInfoCloseBtn"
              />
            </Grid>

            {mainComponent}
          </React.Fragment>
        ) : null}
      </Grid>
    </Grid>
  );
});
RightSideBar.whyDidYouRender = true;
RightSideBar.displayName = 'RightSideBar';

export default RightSideBar;
